import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppErrorBoundary } from "@froppio/web-telemetry";
import { renderCrashScreen } from "./core/telemetry/renderCrashScreen";
import {
  createTelemetryCaches, initTelemetry, installClickTelemetry, reactRootErrorHandlers,
} from "./core/telemetry/telemetry";
import App from "./App.tsx";

// Start before rendering so startup crashes are reported.
initTelemetry();
installClickTelemetry();

const queryClient = new QueryClient({
  ...createTelemetryCaches(),
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,
    },
    mutations: {
      retry: 0,
    },
  },
});

createRoot(document.getElementById("root")!, reactRootErrorHandlers).render(
  <StrictMode>
    <AppErrorBoundary scope="app" fallback={renderCrashScreen}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>
);